import {lazy} from 'react';

export const SpecialistFriendsAsync = lazy(() =>
    import('./SpecialistFriends')
);
